import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DialogElement } from './../models/dialog.model';
import { DialogComponent } from './../dialog/dialog.component';
import { ConfigurationElement } from './../models/configuration.model';
import { ConfigurationComponent } from './../configuration/configuration.component';
import { AlarmConfigurationComponent } from '../alarm-configuration/alarm-configuration.component';
import { DeviceScannerComponent } from '../device-scanner/device-scanner.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(private matDialog: MatDialog) { }

  confirmDialog(data: DialogElement): Observable<boolean> {
    return this.matDialog
      .open(DialogComponent, {
        data,
        width: '450px',
        disableClose: true,
      })
      .afterClosed();
  }

  openConfiguration(data: ConfigurationElement): Observable<boolean> {
    return this.matDialog
      .open(ConfigurationComponent, {
        data,
        width: '600px',
        disableClose: true,
      })
      .afterClosed();
  }

  openAlarmConfiguration(parent_type: string, parent_id: string): Observable<boolean> {
    return this.matDialog
      .open(AlarmConfigurationComponent, {
        data: { parent_type: parent_type, parent_id: parent_id }
      })
      .afterClosed();
  }

  openScanner(): Observable<string> {
    return this.matDialog
      .open(DeviceScannerComponent, {
      })
      .afterClosed();
  }

}
